import { useEffect } from "react";
import { useNavigate} from "react-router-dom";
import AuthService from "@services/auth/auth.service";


const LoginPage = () => {
    const navigate = useNavigate();
    const authService = AuthService.getInstance();

    useEffect(() => {
        if (authService.ssoLoginUrl) {
            // Custom domain with SSO configured — redirect directly to SSO provider
            window.location.href = authService.ssoLoginUrl;
        } else if (authService.nextAppUrl) {
            // Frontegg login is configured on the primary (frontend2) app — redirect there
            // Pass the original path so frontend2 can redirect back after login
            const returnTo = localStorage.getItem('returnPath') || '/';
            localStorage.removeItem('returnPath');
            const legacyReturnUrl = `${window.location.origin}${returnTo}`;
            window.location.href = `${authService.nextAppUrl}/login?returnTo=${encodeURIComponent(legacyReturnUrl)}`;
        }
    }, []);

    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        Redirecting to login...
    </div>

}

export default LoginPage;
